"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HilSigmaModelDefinitionParameterEntry = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const hil_value_variance_js_1 = require("./hil-value-variance.js");
const zod_1 = require("zod");
const hilSigmaModelDefinitionParameterEntrySchema = zod_1.z.object({
    name: zod_1.z.string(),
    description: zod_1.z.string().nullable(),
    boundaryClasses: zod_1.z.nativeEnum(sigma_engine_shared_1.BoundaryClass).array(),
    otherNames: zod_1.z.string().array(),
    required: zod_1.z.boolean(),
    isValueParameter: zod_1.z.boolean(),
    defaultValueVariance: hil_value_variance_js_1.HilValueVariance.schema.nullable(),
    units: zod_1.z
        .object({
        short: zod_1.z.string().optional(),
        long: zod_1.z.string().optional(),
        alternateNames: zod_1.z.string().array().optional(),
        usesSIPrefixes: zod_1.z.boolean().optional(),
        epsilon: zod_1.z.number().optional(),
    })
        .nullable(),
});
exports.HilSigmaModelDefinitionParameterEntry = {
    create(input) {
        return hilSigmaModelDefinitionParameterEntrySchema.parse(input);
    },
    parse(input) {
        return hilSigmaModelDefinitionParameterEntrySchema.parse(input);
    },
    schema: hilSigmaModelDefinitionParameterEntrySchema,
};
//# sourceMappingURL=hil-sigma-model-definition-parameter-entry.js.map